import {Dot} from 'recharts';
import styled, {useTheme} from 'styled-components';

import {PriceMapChartItem} from '../types/PriceMapChartItem';
import {getChartItemColor} from '../utils/getChartItemColor';
import {MyVehicleShape} from './MyVehicleShape';

const DOT_RADIUS = 8;

interface ScatterShapeProps {
  x?: number; // Passed by recharts
  y?: number; // Passed by recharts
  width?: number; // Passed by recharts
  payload?: PriceMapChartItem;
  selectedVehicleId: string | null;
}

export function ScatterShape(props: ScatterShapeProps) {
  const theme = useTheme();

  const isMyVehicle = props.payload?.car.isMyVehicle;

  if (isMyVehicle) {
    return <MyVehicleShape {...props} />;
  }

  const color = props.payload
    ? getChartItemColor(
        theme,
        props.payload?.car,
        props.selectedVehicleId === props.payload.car.ad_id
      )
    : undefined;

  return <DotWithHover {...props} r={DOT_RADIUS} fill={color} />;
}

// ScatterChart has different onMouseMove prop (there is missing activeTooltipIndex attribute)
const DotWithHover = styled(Dot)`
  &:hover {
    fill: ${({theme}) => theme.colors.palettes.blue['40']['100']};
  }
`;
